export const SERVICE_AGREEMENT_FILE_URI = '/files/Web Demo Service Agreement - MVision.pdf';
